import "./EnhancedPrimeReactDatePicker.css";

import { Box, FormHelperText, GridSize } from "@mui/material";
import {
	FieldLayout,
	ITest,
	LabelPosition,
	LayoutWithLabel,
} from "@websential/cosmic-v20";
import React, { FC, useState } from "react";

import { Calendar } from "primereact/calendar";
import TextField from "@mui/material/TextField";

export interface IEnhancedPrimeReactDatePicker extends LayoutWithLabel, ITest {
	/**
	 * Set date picker field name.
	 */
	name: string;
	/**
	 * React hook form field value
	 */
	value: any;
	/**
	 * React hook form onChange function
	 */
	onChange: (date: Date | null | any, value?: string | null | any) => void;
	onDateSelectionChangeHandler?: (date: Date | null, value?: string | null) => void;
	/**
	 * Set the format of date.
	 */
	format?: string;
	/**
	 * Set the initial Label, show in field like placeholder.
	 */
	invalidLabel?: string;
	/**
	 * To show masked value like ******* .
	 */
	masked?: boolean;
	/**
	 * Disable picker and text field.
	 */
	disabled?: boolean;
	/**
	 * Disable future dates, default false.
	 */
	disableFuture?: boolean;
	/**
	 * Max selectable date, default Date(2100-01-01)
	 */
	maxDate: Date;
	/**
	 * Min  selectable date, default Date(1900-01-01)
	 */
	minDate: Date;
	/**
	 * Error message to be displayed
	 */
	helperText?: string | any;

	showlabel?: boolean;
	viewDate: Date
}

export const EnhancedPrimeReactDatePicker: FC<
	IEnhancedPrimeReactDatePicker
> = ({
	name,
	label,
	showlabel,
	labelPosition = LabelPosition.Top,
	labelColumns = 4 as GridSize,
	fieldColumns = 8 as GridSize,
	format = "MMM D, YYYY",
	disabled = false,
	disableFuture = false,
	required = false,
	// masked = true,
	maxDate,
	minDate,
	testId,
	value = "",
	helperText,
	onChange,
	viewDate
}) => {
		return (
			<>
				{showlabel ? (
					<FieldLayout
						label={label}
						isRequired={required}
						testId={testId}
						labelPosition={labelPosition}
						labelColumns={labelColumns}
						fieldColumns={fieldColumns}
						fieldTopPadding={0.8}
					>
						<Box className="calenderDatePickerWithRange">
							<Calendar
								id={name}
								value={value}
								showIcon
								disabled={
									disabled
										? disabled :
										value !== null &&
											typeof value !== "object" &&
											value.charAt(3) === "*"
											? true
											: false
								}
								className="w-full calender"
								style={{ height: "2.6rem", margin: "8px 0px 4px 0px" }}
								onChange={onChange}
								dateFormat="M dd, yy"
								placeholder={
									value !== null &&
										typeof value !== "object" &&
										value.charAt(2) === "*"
										? "Unmask to view / edit"
										: // value === null
										//   ? "Unmask to view / edit"
										"dd/mm/yyyy"
								}
								minDate={minDate}
								maxDate={maxDate}
								readOnlyInput
								showButtonBar
								viewDate={viewDate}
							/>
							<FormHelperText
								sx={{
									margin: "4px 14px 0 0px",
								}}
								error
								role="alert"
							>
								{helperText}
							</FormHelperText></Box>
					</FieldLayout>
				) : (
					<Box className="calenderDatePickerWithRange">
						<Calendar
							id={name}
							value={value}
							showIcon
							disabled={
								disabled
									? disabled
									: value !== null &&
										typeof value !== "object" &&
										value.charAt(3) === "*"
										? true
										: false
							}
							className="w-full calender"
							style={{ height: "2.6rem", margin: "8px 0px 4px 0px" }}
							onChange={onChange}
							dateFormat="M dd, yy"
							placeholder={
								value !== null &&
									typeof value !== "object" &&
									value.charAt(2) === "*"
									? "Unmask to view / edit"
									: "dd/mm/yyyy"
							}
							minDate={minDate}
							maxDate={maxDate}
							readOnlyInput
							showButtonBar
							viewDate={viewDate}
						/></Box>
				)}
			</>
		);
	};
